<template>
  <section :id="`uuid-${$attrs.uuid}`" class="section hub-links">
    <div class="section__container">
      <div class="hub-links__title">
        <h4>{{ hubLinksTitle }}</h4>
      </div>
      <div class="grid-x align-center">
        <div v-for="hub in hubLinks" :key="hub.uuid" class="hub-links__link-container">
          <hub-links-button-wrapper :hub-links-obj="hub" :analyticsData="analyticsData(hub)" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {mgnlComponentMixin} from "@wl-vue-mixins/mixins.js";
import HubLinksButtonWrapper from "@wl-components/HubLinksButtonWrapper/Hub-Links-Button-Wrapper.vue";

export default {
  mixins: [mgnlComponentMixin], // !!! all the mgnl components must be configured with mgnlComponentMixin !!!

  name: "HubLinks",
  inheritAttrs: false,
  components: {
    HubLinksButtonWrapper
  },
  props: {
    hubLinks: {
      type: Array,
      default: () => []
    },
    hubLinksTitle: {
      type: String
    }
  },
  computed: {
    /*    title() {
          const ctx = this;
          return marketingToolId => {
            return ctx.$msg(`common.floating-shortcuts.${marketingToolId}.text`);
          }
        },*/
  },
  methods: {
    analyticsData(el) {
      return {
        evCategory: 'call_to_action',
        evAction: el.document?.url || el.link?.url || el.trackingLabel,
        evLabel: `${el.campaignId || 'No Campaign'} | ${this.common.actpageFullUrl}`
      }
    }
  }
};
</script>